export const LocalStorageKey = {
  STATIC_CONFIG: "STATIC_CONFIG",
  EXPAND: "EXPAND",
  CONFIG_COLOR: "CONFIG_COLOR",
  BASEMAP_SELECTED: "basemapSelected",
  REDIRECT_AFTER_LOGIN: "redirect_after_login",
};
